import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from "@angular/router";
import { AppMode, AppModeService } from "../utility/app-mode.service";
import { map, take } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AppModeGuard implements CanActivateChild {

  constructor(
    private srvAppMode: AppModeService,
    private router: Router,
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.srvAppMode.mode$.pipe(take(1),map(mode => {
        const url = state.url;
        const isDemoUrl = url.startsWith('/demo') || url.startsWith('/secured/demo');

        if (mode === AppMode.WEB && isDemoUrl) {
          return this.router.createUrlTree(['/login']);
        }
        return true;
      })
    );
  }
}